<template>
    <div class="wrapper">
        <div class="filter-pane-wrapper" :class="{'is-open': filterIsOpen}">
            <div class="filter-pane">
                <header>
                    {{ lang('Events Filter') }}
                    <button class="delete is-large" @click="filterIsOpen = false"></button>
                </header>

                <b-field v-for="location in locations" :key="location.id">
                    <b-switch v-model="filteredLocations" :native-value="location" :type="'is-location-' + location.id">
                        <b-tag :type="'is-location-' + location.id">{{ location.name }}</b-tag>
                    </b-switch>
                </b-field>

                <hr>

                <b-field v-for="type in eventTypes" :key="type.name">
                    <b-switch v-model="filteredTypes" :native-value="type.name" :type="'is-' + type.name.toLowerCase()">
                        <b-tag :type="'is-' + type.name.toLowerCase()">{{ type.name }}</b-tag>
                    </b-switch>
                </b-field>

                <template v-if="isAdmin">
                    <b-field>
                        <b-select v-model="showEventsOfUserId">
                            <option :value="0" selected="selected" v-if="$config.key_masters.length > 1">{{ lang('All Owners') }}</option>
                            <option :value="-1">{{ lang('Needs Trainers') }}</option>
                            <optgroup v-for="role in ['Admin', 'Hallenöffner', 'Trainer']" :key="role" :label="role">
                                <option v-for="keyMaster in usersOfRole(role)" :key="keyMaster.id" :value="keyMaster.id">{{ keyMaster.name }}</option>
                            </optgroup>
                        </b-select>
                        <p class="control" v-if="showEventsOfUserId!=0">
                            <button class="button is-danger" @click="showEventsOfUserId=0" :title="lang('All Owners')"><i class="fa fa-times"></i></button>
                        </p>
                    </b-field>
                </template>
                <template v-else-if="selectable">
                    <b-field>
                        <b-switch v-model="showOnlyUsersOwnEvents">
                            {{ lang('Mine') }}
                        </b-switch>
                    </b-field>
                    <b-field v-if="$auth.user.role == 'Trainer'">
                        <b-switch v-model="showEventsOfUserId" :true-value="-1" :false-value="0">
                            {{ lang('Needing trainers') }}
                        </b-switch>
                    </b-field>
                </template>
                <template v-if="isMember">
                    <b-field>
                        <b-switch v-model="showOnlyUsersRegisteredEvents">
                            {{ lang('My registrations') }}
                        </b-switch>
                    </b-field>
                    <b-field>
                        <b-switch v-model="showOnlyEventsWithSpace">
                            {{ lang('Available spots') }}
                        </b-switch>
                    </b-field>
                </template>
            </div>
        </div>

        <b-modal :active.sync="Object.keys(event).length !== 0 && (showEvent || showEventForm)" has-modal-card :canCancel="['escape', 'outside']" :onCancel="eventFormClosed">
            <event
                class="modal-content"
                :ev="event"
                :l="l"
                :is-admin="isAdmin"
                @close="event = {};showEvent = false;"
                @edit="editEvent"
                @delete="confirmDeleteEvent"
                @duplicate="duplicateEvent"
                @withdraw="confirmWithdraw"
                @enlist="confirmEnlist"
                @register="confirmRegister"
                @deregister="confirmDeregister"
                v-show="!showEventForm"
            ></event>

            <div class="modal-card" v-if="showEventForm" v-show="showEventForm">
                <header class="modal-card-head">
                    <p class="modal-card-title">Veranstaltung Speichern</p>
                </header>
                <section class="modal-card-body">
                    <form @submit.prevent="onSubmitEventForm">
                        <!-- <section> -->

                            <div class="field">
                                <div class="control">
                                    <input class="input is-small" :class="{'is-danger': formErrors.title}" type="text" placeholder="Titel" v-model="editedEvent.title" :disabled="!changeOptions.selected.available && !changeOptions.future.available">
                                </div>
                                <p v-show="formErrors.title" v-for="error in formErrors.title" :key="error" class="help is-danger">{{ error }}</p>
                            </div>

                            <div class="field">
                                <div class="control">
                                    <textarea class="textarea is-small" placeholder="Beschreibung" rows="2" v-model="editedEvent.extendedProps.description" :disabled="!changeOptions.selected.available && !changeOptions.future.available"></textarea>
                                </div>
                            </div>

                            <div v-if="isAdmin" class="field">
                                <div class="control">
                                    <textarea class="textarea is-small" placeholder="Private Beschreibung" rows="2" v-model="editedEvent.extendedProps.private_description" :disabled="!changeOptions.selected.available && !changeOptions.future.available"></textarea>
                                </div>
                            </div>

                            <div class="field">
                                <div class="control">
                                    <input class="input is-small" :class="{'is-danger': formErrors.info_link}" type="text" placeholder="Info Link: z.B. https://lebenbewegt-ev.de/" v-model="editedEvent.extendedProps.info_link" :disabled="!changeOptions.selected.available && !changeOptions.future.available">
                                </div>
                                <p v-show="formErrors.info_link" v-for="error in formErrors.info_link" :key="error" class="help is-danger">{{ error }}</p>
                            </div>

                            <div class="field is-horizontal">
                                <div class="field-label is-small">
                                    <label class="label">Art</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <div class="select is-small" :class="{'is-danger': formErrors.type}">
                                                <select v-model="editedEvent.extendedProps.type" :disabled="!changeOptions.selected.available && !changeOptions.future.available" @change="eventTypeChanged()">
                                                    <option disabled value="" selected="selected" v-if="allowedEventTypes.length > 1">-Wähle eines-</option>
                                                    <option v-for="type in allowedEventTypes" :key="type" :value="type">{{ type }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <p v-show="formErrors.type" v-for="error in formErrors.type" :key="error" class="help is-danger">{{ error }}</p>
                                    </div>

                                    <div v-if="isAdmin" class="field">
                                        <b-field>
                                            <b-select
                                                v-model="editedEvent.extendedProps.required_user_count"
                                                size="is-small">
                                                <option
                                                    v-for="count in [0,1,2,3,4,5,6]"
                                                    :key="count"
                                                    :value="count">
                                                    Trainer benötigt: {{ count }}
                                                </option>
                                            </b-select>
                                        </b-field>
                                    </div>
                                </div>
                            </div>

                            <div v-show="['Offen', 'Kurs'].includes(editedEvent.extendedProps.type)" class="field is-horizontal">
                                <div class="field-label is-small">
                                    <label class="label">Plätze</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <b-field>
                                            <b-select
                                                v-model="editedEvent.extendedProps.member_registrant_limit"
                                                size="is-small">
                                                <option
                                                    v-for="limit in [0,1,2,3,4,5,6,7,8,9,10]"
                                                    :key="limit"
                                                    :value="limit">
                                                    Mitglieder: {{ limit }}
                                                </option>
                                            </b-select>
                                        </b-field>
                                    </div>

                                    <div class="field">
                                        <b-field>
                                            <b-select
                                                v-model="editedEvent.extendedProps.kmms_registrant_limit"
                                                size="is-small">
                                                <option
                                                    v-for="limit in [0,1,2,3,4,5,6,7,8,9,10]"
                                                    :key="limit"
                                                    :value="limit">
                                                    KMMS: {{ limit }}
                                                </option>
                                            </b-select>
                                        </b-field>
                                    </div>
                                </div>
                            </div>

                            <div v-if="isAdmin" class="field is-horizontal">
                                <div class="field-label is-small">
                                    <label class="label">Besitzer</label>
                                </div>
                                <div class="field-body">
                                    <b-field :type="{'is-danger': formErrors.users}" :message="formErrors.users">
                                        <b-taginput
                                            v-model="editedEvent.extendedProps.users"
                                            :data="filteredKeyMasters"
                                            autocomplete
                                            :open-on-focus="true"
                                            size="is-small"
                                            field="name"
                                            placeholder="auswählen oder eingeben"
                                            @focus="filterKeyMasters"
                                            @typing="filterKeyMasters">
                                            <template slot-scope="props">
                                                {{props.option.name}} (<span class="has-text-grey-light">{{props.option.role}}</span>)
                                            </template>
                                        </b-taginput>
                                    </b-field>
                                </div>
                            </div>

                            <div class="field is-horizontal">
                                <div class="field-label is-small">
                                    <label class="label">Teilnehmer</label>
                                </div>
                                <div class="field-body">
                                    <b-field :type="{'is-danger': formErrors.registrants}" :message="formErrors.registrants">
                                        <b-taginput
                                            v-model="editedEvent.extendedProps.registrants"
                                            :data="filteredMembers"
                                            autocomplete
                                            :open-on-focus="true"
                                            size="is-small"
                                            field="name"
                                            placeholder="auswählen oder eingeben"
                                            @focus="filterMembers"
                                            @typing="filterMembers">
                                            <template slot-scope="props">
                                                {{props.option.name}} (<span class="has-text-grey-light">{{props.option.role}}</span>)
                                            </template>
                                        </b-taginput>
                                    </b-field>
                                </div>
                            </div>

                            <div class="field is-horizontal">
                                <div class="field-label is-small">
                                    <label class="label">Hallen</label>
                                </div>
                                <div class="field-body">
                                    <b-field :type="{'is-danger': formErrors.locations}" :message="formErrors.locations">
                                        <b-taginput
                                            v-model="editedEvent.extendedProps.locations"
                                            :data="locations"
                                            autocomplete
                                            :open-on-focus="true"
                                            size="is-small"
                                            field="name"
                                            placeholder="auswählen oder eingeben">
                                            <template slot-scope="props">
                                                {{props.option.name}}
                                            </template>
                                        </b-taginput>
                                    </b-field>

                                    <div class="field">
                                        <div class="control">
                                            <label class="checkbox">
                                                <input v-model="editedEvent.extendedProps.halle_frei" type="checkbox" class="is-small">
                                                Frei
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="isAdmin" class="field is-horizontal">
                                <div class="field-label is-small">
                                    <label class="label">Unsichtbar</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <input v-model="editedEvent.extendedProps.masked" type="checkbox" class="is-small">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="field">
                                <div class="field is-horizontal">
                                    <div class="field-label is-small">
                                        <label class="label">Start</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <div class="field has-addons">
                                                <div class="control">
                                                    <b-field class="is-small" :class="{'is-danger': formErrors.start}" :disabled="!changeOptions.selected.available && !changeOptions.future.available">
                                                        <b-datepicker placeholder="Datum auswählen" size="is-small" v-model="editedEvent.start" :date-formatter="(date) => date.toLocaleDateString(l)" :month-names="months()" :day-names="weekdaysShort(false)" :first-day-of-week="1">
                                                        </b-datepicker>
                                                    </b-field>
                                                </div>
                                                <div class="control">
                                                    <a class="button is-static is-small">
                                                        um
                                                    </a>
                                                </div>
                                                <div class="control">
                                                    <input class="input is-small" :class="{'is-danger': formErrors.start}" type="text" v-model="editedEvent.startTime" :disabled="!changeOptions.selected.available && !changeOptions.future.available">
                                                </div>
                                            </div>
                                            <p v-show="formErrors.start" v-for="error in formErrors.start" :key="error" class="help is-danger">{{ error }}</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="field is-horizontal">
                                    <div class="field-label is-small">
                                        <label class="label">Ende</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <div class="field has-addons">
                                                <div class="control">
                                                    <b-field class="is-small" :class="{'is-danger': formErrors.end}" :disabled="!changeOptions.selected.available && !changeOptions.future.available">
                                                        <b-datepicker placeholder="Datum auswählen" size="is-small" v-model="editedEvent.end" :date-formatter="(date) => date.toLocaleDateString(l)" :month-names="months()" :day-names="weekdaysShort(false)" :first-day-of-week="1">
                                                        </b-datepicker>
                                                    </b-field>
                                                </div>
                                                <div class="control">
                                                    <a class="button is-static is-small">
                                                        um
                                                    </a>
                                                </div>
                                                <div class="control">
                                                    <input class="input is-small" :class="{'is-danger': formErrors.end}" type="text" v-model="editedEvent.endTime" :disabled="!changeOptions.selected.available && !changeOptions.future.available">
                                                </div>
                                            </div>
                                            <p v-show="formErrors.end" v-for="error in formErrors.end" :key="error" class="help is-danger">{{ error }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="field is-horizontal">
                                <div class="field-label is-small">
                                    <label class="label">Häufigkeit</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <div class="select is-small">
                                                <select v-model="editedEvent.extendedProps.frequency" :disabled="!changeOptions.future.available && !changeOptions.all.available" @change="frequencyChanged">
                                                    <option v-for="option in frequencyOptions" :key="option.value" :value="option.value" :disabled="option.disabled">{{ option.label }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <p v-show="formErrors.frequency" v-for="error in formErrors.frequency" :key="error" class="help is-danger">{{ error }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="field" v-show="editedEvent.extendedProps.frequency">
                                <div class="field is-horizontal" v-show="editedEvent.extendedProps.frequency == 'WEEKLY'">
                                    <div class="field-label is-small">
                                        <label class="label">Am</label>
                                    </div>
                                    <div class="field-body">
                                        <b-field>
                                            <b-checkbox-button v-model="editedEvent.extendedProps.by_day" v-for="(day, i) in weekdaysShort(true)" :key="i" :native-value="day" type="is-success" size="is-small">{{ day }}</b-checkbox-button>
                                        </b-field>
                                    </div>
                                </div>

                                <div class="field is-horizontal">
                                    <div class="field-label is-small">
                                        <label class="label">Abstand</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="control">
                                            <input class="input is-small" v-model="editedEvent.extendedProps.interval" type="text">
                                        </div>
                                    </div>
                                </div>

                                <div class="field is-horizontal">
                                    <div class="field-label is-small">
                                        <label class="label">Ende</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field" :class="{'has-addons': ['After', 'On Date'].includes(editedEvent.extendedProps.end_repeat)}">
                                            <div class="control">
                                                <div class="select is-small">
                                                    <select v-model="editedEvent.extendedProps.end_repeat" :disabled="!changeOptions.all.available">
                                                        <option value="Never">Nie</option>
                                                        <option value="On Date">Am Tag</option>
                                                        <option value="After">Nach</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="control" v-show="editedEvent.extendedProps.end_repeat == 'On Date'">
                                                <b-field label="" :disabled="!changeOptions.all.available">
                                                    <b-datepicker placeholder="Datum auswählen" size="is-small" v-model="editedEvent.extendedProps.until" :min-date="minDate()" :date-formatter="(date) => date.toLocaleDateString(l)" :month-names="months()" :day-names="weekdaysShort(false)" :first-day-of-week="1">
                                                    </b-datepicker>
                                                </b-field>
                                            </div>

                                            <div class="control" v-show="editedEvent.extendedProps.end_repeat == 'After'">
                                                <input class="input is-small" type="text" v-model="editedEvent.extendedProps.count" :disabled="!changeOptions.all.available">
                                            </div>
                                            <div class="control" v-show="editedEvent.extendedProps.end_repeat == 'After'">
                                                <a class="button is-static is-small">
                                                    Mal
                                                </a>
                                            </div>
                                        </div>
                                        <p v-show="formErrors.until && editedEvent.extendedProps.end_repeat == 'On Date'" v-for="error in formErrors.until" :key="error" class="help is-danger">{{ error }}</p>
                                    </div>
                                </div>

                                <div class="field is-horizontal">
                                    <div class="field-label is-small">
                                        <label class="label">Feiertage ausschließen</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <div class="control">
                                                <input v-model="editedEvent.extendedProps.observe_holidays" type="checkbox" class="is-small">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        <!-- </section> -->
                    </form>
                </section>
                <footer class="modal-card-foot">
                    <button type="submit" :class="{'is-loading': isLoading}" class="button is-primary" @click="onSubmitEventForm">{{ lang('Save') }}</button>
                    <button type="reset" class="button" @click="eventFormClosed">{{ lang('Cancel') }}</button>
                </footer>
            </div>
        </b-modal>

        <div id="calendar-container">
            <FullCalendar
                ref="calendar"
                :locale="locale"
                :defaultView="defaultView"
                :columnHeaderFormat="columnHeaderFormat"
                :plugins="calendarPlugins"
                :events="events"
                :eventSources="eventSources"
                :resources="resources"
                :datesAboveResources="true"
                :schedulerLicenseKey="'CC-Attribution-NonCommercial-NoDerivatives'"
                :height="height"
                :header="header"
                :views="views"
                :customButtons="customButtons"
                :allDaySlot="allDaySlot"
                :weekNumbers="weekNumbers"
                :slotLabelFormat="slotLabelFormat"
                :scrollTime="scrollTime"
                :navLinks="navLinks"
                :nowIndicator="nowIndicator"
                :businessHours="businessHours"
                :minTime="minTime"
                :maxTime="maxTime"
                :selectable="selectable"
                :selectAllow="selectAllow"
                :selectMirror="selectMirror"
                :selectOverlap="selectOverlap"
                :eventOverlap="eventOverlap"
                :eventAllow="eventAllow"
                :eventColor="eventColor"
                :eventTextColor="eventTextColor"
                :allDayDefault="allDayDefault"
                :eventRender="eventRender"
                @viewSkeletonRender="viewSkeletonRender"
                @eventClick="eventClick"
                @select="select"
                @eventDrop="eventDropped"
                @eventResize="eventResized"
            />
        </div>

        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import resourceDayGridPlugin from "@fullcalendar/resource-daygrid";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import listPlugin from "@fullcalendar/list";
import deLocale from '@fullcalendar/core/locales/de';

import Event from "./Event";
import ModalDialog from "./modal-dialog/ModalDialog";

export default {
    name: "calendar",
    components: { FullCalendar, Event, ModalDialog },
    data() {
        return {
            locale: deLocale,
            l: 'de',
            calendarPlugins: [ interactionPlugin, dayGridPlugin, timeGridPlugin, resourceDayGridPlugin, resourceTimeGridPlugin, listPlugin ],
            height: "parent",
            customButtons: {
                eventsFilter: {
                    icon: 'fa fa fa-sliders',
                    click: () => this.filterIsOpen = !this.filterIsOpen,
                },
                locationSwitcher: {
                    text: 'OG/EG',
                    click: this.switchLocationVisibility,
                },
                addEvent: {
                    icon: 'fa fa fa-plus',
                    click: () => this.createEvent(),
                }
            },
            defaultView: 'resourceTimeGridWeek',
            columnHeaderFormat: {
                weekday: 'short',
                month: 'numeric',
                day: 'numeric',
                omitCommas: true
            },
            allDaySlot: false,
            weekNumbers: true,
            slotLabelFormat: {
                hour: "2-digit",
                minute: "2-digit",
            },
            scrollTime: "09:00",
            navLinks: true,
            nowIndicator: true,
            businessHours: {},
            minTime: '06:00',
            maxTime: '22:00',

            selectable: false,
            selectMirror: true,
            selectOverlap: false,
            eventOverlap: false,
            isAdmin: false,

            event: {},
            editedEvent: {},
            eventColor: "rgba( 85,147, 92,1)",
            eventTextColor: "rgba(247,250,247,1)",
            allDayDefault: false,
            events: [],
            showEvent: false,
            showEventForm: false,
            formErrors: {},
            locations: [
                {
                    id: 1,
                    name: "OG",
                },
                {
                    id: 2,
                    name: "EG",
                },
            ],
            eventTypes: [
                //http://paletton.com/palette.php?uid=72R0u0kdCnO0mY169x0kQh4zF6Y
                {
                    name: "Offen",
                    // color: '#51b749'
                    // color: 'hsl(141, 71%, 48%)'
                    color: "rgba( 85,147, 92,1)",
                    textColor: "rgba(247,250,247,1)"
                },
                {
                    name: "Privat",
                    // color: '#dc2127'
                    // color: 'hsl(348, 100%, 61%)'
                    color: "rgba(190,113,109,1)",
                    textColor: "rgba(255,252,252,1)"
                },
                {
                    name: "Kurs",
                    color: "rgba(85,109,147,1)",
                    textColor: "rgba(255,254,252,1)"
                },
                {
                    name: "Kindergeburtstag",
                    color: "rgba(190,113,109,1)",
                    textColor: "rgba(255,252,252,1)"
                },
                {
                    name: "Gruppe",
                    color: "rgba(191, 127, 63,1)",
                    textColor: "rgba(255,254,252,1)"
                },
                {
                    name: "Sonst",
                    // color: '#7ae7bf'
                    // color: 'hsl(171, 100%, 41%)'
                    color: "rgba(168, 168, 70,1)",
                    textColor: "rgba(255,255,255,1)"
                },
                {
                    name: "Geschlossen",
                    // color: '#e1e1e1'
                    color: "hsl(0, 0%, 86%)",
                    textColor: "hsl(0, 0%, 21%)"
                }
            ],
            filterIsOpen: false,
            filteredLocations: [],
            filteredTypes: [],
            filteredKeyMasters: [],
            filteredMembers: [],
            showOnlyUsersOwnEvents: false,
            showEventsOfUserId: 0,
            showOnlyUsersRegisteredEvents: false,
            showOnlyEventsWithSpace: false,
            selectedValue: new Date(),
            isLoading: false,
            views: {
                resourceTimeGridFourDay: {
                    type: 'resourceTimeGrid',
                    duration: { days: 4 },
                    buttonText: '4 Tage'
                },
                timeGridFourDay: {
                    type: 'timeGrid',
                    duration: { days: 4 },
                    buttonText: '4 Tage'
                },
            },
        };
    },
    methods: {
        switchLocationVisibility() {
            if (this.filteredLocations.length == 1) {
                var currentVisibleLocation = this.filteredLocations[0];
                this.filteredLocations = [this.locations.find(l => l.id != currentVisibleLocation.id)];
            } else {
                this.filteredLocations = [this.locations[0]];
            }
        },
        viewSkeletonRender(info) {
            if (info.view.type === 'resourceDayGridMonth') {
                this.columnHeaderFormat = {weekday: 'short'};
            } else {
                this.columnHeaderFormat = {
                    weekday: 'short',
                    month: 'numeric',
                    day: 'numeric',
                    omitCommas: true
                };
            }
        },
        refreshEvents() {
            let calendarApi = this.$refs.calendar.getApi();
            // calendarApi.refetchEvents(); // refetches from all event sources
            calendarApi.getEventSourceById('boulder-halle').refetch();
        },
        eventRender(info) {
            if (info.event.extendedProps.is_user_registered) {
                const timeNode = info.el.querySelector('.fc-time');
                const span = document.createElement('span');
                span.innerHTML = '<i class="fa fa-check"></i>';
                span.setAttribute('class', 'is-registered-for-event');
                span.setAttribute('title', this.lang('You are registered'));
                timeNode.appendChild(span);
            }
            // render event if it is being created
            if (info.event.extendedProps.type == '' || info.isMirror) {
                return true;
            }
            let eventUserIds = _.map(info.event.extendedProps.users, 'id');
            // don't render event if the user's own event filter is toggled and event does not belong to user
            if (this.showOnlyUsersOwnEvents && !eventUserIds.includes(this.$auth.user.id)) {
                return false;
            }
            // don't render event if the user filter is toggled and event does not belong to specified user
            // except when 'Needs Trainers' is selected and event has less than max assignable users
            if (
                (this.showEventsOfUserId != 0 && !eventUserIds.includes(this.showEventsOfUserId)) &&
                !(
                    this.showEventsOfUserId == -1 &&
                    eventUserIds.length < info.event.extendedProps.required_user_count
                )
            ) {
                return false;
            }
            // don't render event if the user's registered event filter is toggled and user is not registered for event
            if (this.showOnlyUsersRegisteredEvents && !info.event.extendedProps.is_user_registered) {
                return false;
            }
            // don't render event if the free space event filter is toggled and the event has reach its limit
            if (this.showOnlyEventsWithSpace) {
                return info.event.extendedProps.are_spots_available_for_user;
            }
            // render event if one of its locations is checked in the filter
            if (!this.filteredLocations.map(l => l.id).some(id => info.event.extendedProps.locations.map(eventLocation => eventLocation.id).includes(id))) {
                return false;
            }
            // render event if its type is checked in the filter
            if (this.filteredTypes.includes(info.event.extendedProps.type)) {
                return true;
            }
            return false;
        },
        eventClick(eventClickInfo) {
            if (!this.isAdmin && eventClickInfo.event.rendering == "background") {
                return;
            }
            this.event = eventClickInfo.event;
            this.showEvent = true;
        },
        select(selectionInfo) {
            this.createEvent(selectionInfo);
        },
        usersOfRole(role) {
            return this.$config.key_masters.filter(function (keyMaster) {
                return keyMaster.role === role;
            });
        },
        filterKeyMasters(text) {
            let eventUserIds = _.map(this.editedEvent.extendedProps.users, 'id');
            this.filteredKeyMasters = this.$config.key_masters.filter((option) => {
                return !eventUserIds.includes(option.id);
            });
            let roleToShowFirst = null;
            if (this.editedEvent.extendedProps.type == 'Offen') {
                roleToShowFirst = 'Hallenöffner';
            } else if (['Kurs', 'Kindergeburtstag', 'Gruppe'].includes(this.editedEvent.extendedProps.type)) {
                roleToShowFirst = 'Trainer';
            }
            if (roleToShowFirst) {
                this.filteredKeyMasters = _.sortBy(this.filteredKeyMasters, [function(option) { return option.role != roleToShowFirst; }]);
            }
            if (typeof text != "string") {
                return;
            }
            this.filteredKeyMasters = this.filteredKeyMasters.filter((option) => {
                return option.name
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0;
            });
        },
        filterMembers(text) {
            let eventRegistrantUserIds = _.map(this.editedEvent.extendedProps.registrants, 'id');
            this.filteredMembers = this.$config.members.filter((option) => {
                return !eventRegistrantUserIds.includes(option.id);
            });
            if (typeof text != "string") {
                return;
            }
            this.filteredMembers = this.filteredMembers.filter((option) => {
                return option.name
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0;
            });
        },
        minDate() {
            let date = new Date();
            date = date.setDate(date.getDate() - 1);
            return new Date(date);
        },
        eventTypeChanged() {
            if ('Offen' === this.editedEvent.extendedProps.type && this.editedEvent.extendedProps.locations.length == 0) {
                this.editedEvent.extendedProps.locations = this.locations;
            }
        },
        frequencyChanged() {
            if (
                this.editedEvent.extendedProps.frequency == "WEEKLY" &&
                this.editedEvent.extendedProps.by_day.length == 0
            ) {
                this.editedEvent.extendedProps.by_day.push(
                    this.editedEvent.start.toLocaleString(this.l, { weekday: 'short' }).toUpperCase()
                );
            }
        },
        eventFormClosed() {
            let calendarApi = this.$refs.calendar.getApi();
            calendarApi.unselect();
            if (this.event.id) {
                this.event = _.cloneDeep(this.originalEvent);
            } else {
                this.event.remove();
            }

            this.refreshEvents();
            this.showEventForm = false;
            this.event = {};
            this.editedEvent = {};
            this.showEvent = false;
            this.filteredKeyMasters = this.$config.key_masters;
        },
        onSubmitEventForm() {
            this.editedEvent.start.setHours(this.editedEvent.startTime.split(':')[0], this.editedEvent.startTime.split(':')[1]);
            this.editedEvent.end.setHours(this.editedEvent.endTime.split(':')[0], this.editedEvent.endTime.split(':')[1]);
            this.event.setStart(this.editedEvent.start);
            this.event.setEnd(this.editedEvent.end);
            this.event.setProp('title', this.editedEvent.title);
            this.event.setExtendedProp('description', this.editedEvent.extendedProps.description);
            this.event.setExtendedProp('private_description', this.editedEvent.extendedProps.private_description);
            this.event.setExtendedProp('info_link', this.editedEvent.extendedProps.info_link);
            this.event.setExtendedProp('users', this.editedEvent.extendedProps.users);
            this.event.setExtendedProp('registrants', this.editedEvent.extendedProps.registrants);
            this.event.setExtendedProp('type', this.editedEvent.extendedProps.type);
            this.event.setExtendedProp('required_user_count', this.editedEvent.extendedProps.required_user_count);
            this.event.setExtendedProp('member_registrant_limit', this.editedEvent.extendedProps.member_registrant_limit);
            this.event.setExtendedProp('kmms_registrant_limit', this.editedEvent.extendedProps.kmms_registrant_limit);
            this.event.setExtendedProp('locations', this.editedEvent.extendedProps.locations);
            this.event.setExtendedProp('halle_frei', this.editedEvent.extendedProps.halle_frei);
            this.event.setExtendedProp('masked', this.editedEvent.extendedProps.masked);
            this.event.setExtendedProp('frequency', this.editedEvent.extendedProps.frequency);
            this.event.setExtendedProp('by_day', this.editedEvent.extendedProps.by_day);
            this.event.setExtendedProp('end_repeat', this.editedEvent.extendedProps.end_repeat);
            this.event.setExtendedProp('count', this.editedEvent.extendedProps.count);
            this.event.setExtendedProp('interval', this.editedEvent.extendedProps.interval);
            this.event.setExtendedProp('observe_holidays', this.editedEvent.extendedProps.observe_holidays);
            this.event.setExtendedProp('until', this.editedEvent.extendedProps.until);
            if (this.event.extendedProps.type) {
                this.event.setProp('color', this.eventTypes.find(x => x.name === this.event.extendedProps.type).color);
            }
            this.confirmSaveEvent();
        },
        createEvent(args) {
            if (!args) {
                args = {view:{type:"timeGridWeek"}};
            }
            if (!args.start) {
                let start = new Date();
                start.setHours(start.getHours() + 1, 0, 0);
                let end = new Date(start.getTime());
                end.setHours(end.getHours() + 2, 30, 0);
                args.start = start;
                args.end = end;
            }

            // set defaults for events created from month view
            if (args.view.type == "dayGridMonth") {
                args.allDay = false;
                if (args.start.getHours() > 9) {
                    args.start.setHours(args.start.getHours() + 1, 0, 0);
                } else {
                    args.start.setHours(9, 0, 0);
                }
                let end = new Date(args.start.getTime());
                end.setHours(end.getHours() + 2);
                args.end = end;
            }

            this.resetForm();
            // save start and end dates to event model
            this.editedEvent.start = args.start;
            this.editedEvent.end = args.end;
            let calendarApi = this.$refs.calendar.getApi();
            this.event = calendarApi.addEvent(this.editedEvent);
            this.loadForm();
        },
        eventDropped(eventDropInfo) {
            this.event = eventDropInfo.event;
            // confirm and save event
            this.revertFunc = eventDropInfo.revertFunc;
            this.confirmSaveEvent("datetime", eventDropInfo.revertFunc);
        },
        eventResized(eventResizeInfo) {
            this.event = eventResizeInfo.event;
            // confirm and save event
            this.revertFunc = eventResizeInfo.revertFunc;
            this.confirmSaveEvent("datetime", eventResizeInfo.revertFunc);
        },
        editEvent() {
            this.loadForm();
        },
        duplicateEvent() {
            this.editedEvent = {
                id: undefined,
                start: this.event.start,
                end: this.event.end,
                title: this.event.title,
                extendedProps: {
                    locations: this.event.extendedProps.locations,
                    description: this.event.extendedProps.description,
                    private_description: this.event.extendedProps.private_description,
                    info_link: this.event.extendedProps.info_link,
                    type: this.event.extendedProps.type,
                    required_user_count: this.event.extendedProps.required_user_count,
                    member_registrant_limit: this.event.extendedProps.member_registrant_limit,
                    kmms_registrant_limit: this.event.extendedProps.kmms_registrant_limit,
                    users: this.event.extendedProps.users,
                    registrants: this.event.extendedProps.registrants,
                    halle_frei: this.event.extendedProps.halle_frei,
                    masked: this.event.extendedProps.masked,
                    recurring: this.event.extendedProps.recurring,
                    frequency: this.event.extendedProps.frequency,
                    by_day: this.event.extendedProps.by_day,
                    count: this.event.extendedProps.count,
                    interval: this.event.extendedProps.interval,
                    observe_holidays: this.event.extendedProps.observe_holidays,
                    until: this.event.extendedProps.until,
                    end_repeat: this.event.extendedProps.end_repeat,
                    change_option: this.event.extendedProps.change_option,
                }
            };
            let calendarApi = this.$refs.calendar.getApi();
            this.event = calendarApi.addEvent(this.editedEvent);
            this.editedEvent.startTime = this.event.start.toLocaleString(this.l, {hour: '2-digit', minute: '2-digit'});
            this.editedEvent.endTime = this.event.end.toLocaleString(this.l, {hour: '2-digit', minute: '2-digit'});

            this.formErrors = {};
            this.showEventForm = true;
        },
        resetForm() {
            this.editedEvent = {
                id: undefined,
                start: null,
                end: null,
                title: '',
                extendedProps: {
                    locations: [],
                    description: null,
                    private_description: null,
                    info_link: null,
                    type: this.setEventType(),
                    required_user_count: 1,
                    member_registrant_limit: 0,
                    kmms_registrant_limit: 0,
                    users: [this.$auth.user],
                    registrants: [],
                    halle_frei: true,
                    masked: false,
                    recurring: false,
                    frequency: null,
                    by_day: [],
                    count: 1,
                    interval: 1,
                    observe_holidays: true,
                    until: null,
                    end_repeat: "Never",
                    change_option: null
                }
            };

            this.formErrors = {};
        },
        loadForm() {
            if (this.event.id) {
                this.originalEvent = _.cloneDeep(this.event);

                this.editedEvent = {
                    id: this.event.id,
                    start: this.event.start,
                    end: this.event.end,
                    title: this.event.title,
                    extendedProps: {
                        locations: this.event.extendedProps.locations,
                        description: this.event.extendedProps.description,
                        private_description: this.event.extendedProps.private_description,
                        info_link: this.event.extendedProps.info_link,
                        type: this.event.extendedProps.type,
                        required_user_count: this.event.extendedProps.required_user_count,
                        member_registrant_limit: this.event.extendedProps.member_registrant_limit,
                        kmms_registrant_limit: this.event.extendedProps.kmms_registrant_limit,
                        users: this.event.extendedProps.users,
                        registrants: this.event.extendedProps.registrants,
                        halle_frei: this.event.extendedProps.halle_frei,
                        masked: this.event.extendedProps.masked,
                        recurring: this.event.extendedProps.recurring,
                        frequency: this.event.extendedProps.frequency,
                        by_day: this.event.extendedProps.by_day,
                        count: this.event.extendedProps.count,
                        interval: this.event.extendedProps.interval,
                        observe_holidays: this.event.extendedProps.observe_holidays,
                        until: this.event.extendedProps.until,
                        end_repeat: this.event.extendedProps.end_repeat,
                        change_option: this.event.extendedProps.change_option,
                    }
                };
            }

            this.editedEvent.startTime = this.event.start.toLocaleString(this.l, {hour: '2-digit', minute: '2-digit'});
            this.editedEvent.endTime = this.event.end.toLocaleString(this.l, {hour: '2-digit', minute: '2-digit'});

            this.formErrors = {};
            this.showEventForm = true;
        },
        setEventType() {
            if (this.allowedEventTypes.length === 1) {
                return this.allowedEventTypes[0];
            } else {
                return "";
            }
        },
        saveEvent(changeOption = null) {
            this.isLoading = true;
            var self = this;
            var url = "/events";
            var method = "post";

            var data = {
                start:
                    this.event.start.toLocaleString(this.l, {year: "numeric"}) + "-" +
                    this.event.start.toLocaleString(this.l, {month: "2-digit"}) + "-" +
                    this.event.start.toLocaleString(this.l, {day: "2-digit"}) + " " +
                    this.event.start.toLocaleString(this.l, {hour: '2-digit', minute: '2-digit'}) + ":00",
                end:
                    this.event.end.toLocaleString(this.l, {year: "numeric"}) + "-" +
                    this.event.end.toLocaleString(this.l, {month: "2-digit"}) + "-" +
                    this.event.end.toLocaleString(this.l, {day: "2-digit"}) + " " +
                    this.event.end.toLocaleString(this.l, {hour: '2-digit', minute: '2-digit'}) + ":00",
                recurring: this.event.extendedProps.frequency ? true : false,
                frequency: this.event.extendedProps.frequency
            };

            if (this.event.extendedProps.parent_id) {
                data.id = this.event.extendedProps.parent_id;
                url += "/" + this.event.extendedProps.parent_id;
                method = "patch";
            } else if (this.event.id) {
                data.id = this.event.id;
                url += "/" + this.event.id;
                method = "patch";
            }
            if (this.event.extendedProps.users) {
                data.users = this.event.extendedProps.users;
            }
            if (this.event.extendedProps.registrants) {
                data.registrants = this.event.extendedProps.registrants;
            }
            if (this.event.extendedProps.recurrence_number) {
                data.recurrence_number = this.event.extendedProps.recurrence_number;
            }

            if (this.event.title) {
                data.title = this.event.title;
            }
            if (this.event.extendedProps.description) {
                data.description = this.event.extendedProps.description;
            }
            if (this.event.extendedProps.private_description) {
                data.private_description = this.event.extendedProps.private_description;
            }
            if (this.event.extendedProps.info_link) {
                data.info_link = this.event.extendedProps.info_link;
            }
            if (this.event.extendedProps.type) {
                data.type = this.event.extendedProps.type;
            }
            if (typeof this.event.extendedProps.required_user_count != "undefined") {
                data.required_user_count = this.event.extendedProps.required_user_count;
            }
            if (typeof this.event.extendedProps.member_registrant_limit != "undefined") {
                data.member_registrant_limit = this.event.extendedProps.member_registrant_limit;
            }
            if (typeof this.event.extendedProps.kmms_registrant_limit != "undefined") {
                data.kmms_registrant_limit = this.event.extendedProps.kmms_registrant_limit;
            }
            if (this.event.extendedProps.locations) {
                data.locations = this.event.extendedProps.locations;
            }
            if (typeof this.event.extendedProps.halle_frei != "undefined") {
                data.halle_frei = this.event.extendedProps.halle_frei;
            }
            if (typeof this.event.extendedProps.masked != "undefined") {
                data.masked = this.event.extendedProps.masked;
            }
            if (this.event.extendedProps.by_day) {
                data.by_day = this.event.extendedProps.by_day;
            }
            if (this.event.extendedProps.end_repeat) {
                data.end_repeat = this.event.extendedProps.end_repeat;
            }
            if (this.event.extendedProps.count) {
                data.count = this.event.extendedProps.count;
            }
            if (this.event.extendedProps.interval) {
                data.interval = this.event.extendedProps.interval;
            }
            if (typeof this.event.extendedProps.observe_holidays != "undefined") {
                data.observe_holidays = this.event.extendedProps.observe_holidays;
            }
            if (this.event.extendedProps.until) {
                data.until =
                    this.event.extendedProps.until.toLocaleString(this.l, {year: "numeric"}) + "-" +
                    this.event.extendedProps.until.toLocaleString(this.l, {month: "2-digit"}) + "-" +
                    this.event.extendedProps.until.toLocaleString(this.l, {day: "2-digit"}) + " " +
                    this.event.extendedProps.until.toLocaleString(this.l, {hour: '2-digit', minute: '2-digit'}) + ":00";
            }
            if (changeOption) {
                data.change_option = changeOption;
            }

            // post event to server

            axios({ url, method, data })
                .then(function(response) {
                    self.showEventForm = false;
                    self.event.remove();
                    self.event = {};
                    self.refreshEvents();
                    self.showEvent = false;
                    self.formErrors = {};
                    self.isLoading = false;
                    self.$buefy.toast.open({
                        message: "Gespeichert! Alles ist gut.",
                        type: "is-success",
                        position: "is-top-right"
                    });
                })
                .catch(function(error) {
                    if (!error.response) {
                        self.alertCustomError(error.message);
                    } else {
                        if (
                            error.response.status == 422 &&
                            error.response.data.errors
                        ) {
                            self.formErrors = error.response.data.errors;
                            self.showEventForm = true;
                        } else if (error.response.status == 401) {
                            // unauthorized
                            self.logout();
                        } else if (error.response.status == 419) {
                            // authentication timeout
                            self.alertSessionExpired();
                        } else {
                            self.alertCustomError(error.response.data.message);
                        }
                    }

                    self.isLoading = false;
                });
        },
        confirmSaveEvent(whatChanged = null) {
            // decide if confirmation needed
            if (!this.event.extendedProps.parent_id) {
                this.saveEvent();
                return;
            }

            var self = this;

            var props = {
                title: "Wiederholenden Veranstaltung speichern",
                cancelText: "Beenden",
                type: "is-warning",
                hasIcon: true
            };

            var options = this.changeOptions;

            if (whatChanged == "datetime") {
                props.onCancel = function() {
                    self.refreshEvents();
                };
            }

            if (options.selected.available) {
                props.message =
                    "Möchtest du dieses und alle zukünftigen Vorkommen diese Veranstaltung oder nur das ausgewählte Vorkommen <b>ändern</b>?";
                props.confirmText = options.selected.name;
                props.confirmSecondaryText = options.future.name;
                props.onConfirm = function() {
                    self.saveEvent("selected");
                };
                props.onConfirmSecondary = function() {
                    self.saveEvent("future");
                };
            } else if (options.future.available) {
                props.message =
                    "Möchtest du dieses und alle zukünftigen Vorkommen diese Veranstaltung <b>ändern</b>?";
                props.confirmText = options.future.name;
                props.onConfirm = function() {
                    self.saveEvent("future");
                };
            } else if (options.all.available) {
                props.message =
                    "Möchtest du alle Vorkommen diese Veranstaltung <b>ändern</b>?";
                props.confirmText = options.all.name;
                props.onConfirm = function() {
                    self.saveEvent("all");
                };
            }

            this.$modalDialog.confirm(props);
        },
        deleteEvent(changeOption = null) {
            this.isLoading = true;
            var self = this;
            var url = "/events";

            var data = {
                start: this.event.start
            };

            if (this.event.extendedProps.parent_id) {
                url += "/" + this.event.extendedProps.parent_id;
            } else {
                url += "/" + this.event.id;
            }

            if (this.event.extendedProps.recurrence_number) {
                data.recurrence_number = this.event.extendedProps.recurrence_number;
            }
            if (changeOption) {
                data.change_option = changeOption;
            }

            // delete event

            axios
                .delete(url, { data: data })
                .then(function(response) {
                    self.event.remove();
                    self.event = {};
                    self.showEvent = false;
                    self.refreshEvents();
                    self.isLoading = false;
                    self.$buefy.toast.open({
                        message: "Gelöscht! Alles ist gut.",
                        type: "is-success",
                        position: "is-top-right"
                    });
                })
                .catch(function(error) {
                    if (error.response.status == 401) {
                        // unauthorized
                        self.logout();
                    } else if (error.response.status == 419) {
                        // authentication timeout
                        self.alertSessionExpired();
                    } else {
                        self.alertCustomError(error.response.data.message);
                    }
                    self.isLoading = false;
                });
        },
        confirmDeleteEvent() {
            var self = this;

            var props = {
                title: "Veranstaltung löschen",
                message:
                    "Bist du sicher, dass du diese Veranstaltung <b>löschen</b> möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
                confirmText: "Löschen",
                cancelText: "Beenden",
                type: "is-danger",
                hasIcon: true,
                onConfirm: function() {
                    self.deleteEvent();
                }
            };

            if (this.event.extendedProps.parent_id) {
                props.message =
                    "Möchtest du alle Vorkommen diese Veranstaltung oder nur das ausgewählte Vorkommen <b>löschen</b>?";
                props.confirmText = "Ausgewählte löschen";
                props.confirmSecondaryText = "Alle löschen";
                props.onConfirm = function() {
                    self.deleteEvent("selected");
                };
                props.onConfirmSecondary = function() {
                    self.deleteEvent("all");
                };

                if (this.event.extendedProps.recurrence_number > 1) {
                    props.message =
                        "Möchtest du dieses und alle zukünftigen Vorkommen diese Veranstaltung oder nur das ausgewählte Vorkommen <b>löschen</b>?";
                    props.confirmSecondaryText = "Alle zukünftigen löschen";
                    props.onConfirmSecondary = function() {
                        self.deleteEvent("future");
                    };
                }
            }

            this.$modalDialog.confirm(props);
        },
        withdraw(changeOption = null) {
            this.isLoading = true;
            var self = this;
            var url = "/events/withdraw/" + this.event.id;

            var data = {
                start: this.event.start
            };

            // remove user from event

            axios
                .patch(url, data)
                .then(function(response) {
                    self.event = {};
                    self.refreshEvents();
                    self.showEvent = false;
                    self.isLoading = false;
                    self.$buefy.toast.open({
                        message: "Gespeichert! Alles ist gut.",
                        type: "is-success",
                        position: "is-top-right"
                    });
                })
                .catch(function(error) {
                    if (!error.response) {
                        self.alertCustomError(error.message);
                    } else {
                        if (error.response.status == 401) {
                            // unauthorized
                            self.logout();
                        } else if (error.response.status == 419) {
                            // authentication timeout
                            self.alertSessionExpired();
                        } else {
                            self.alertCustomError(error.response.data.message);
                        }
                    }
                    self.isLoading = false;
                });
        },
        confirmWithdraw() {
            var self = this;

            var props = {
                title: "Von Veranstaltung austragen",
                message:
                    "Bist du sicher, dass du dich von dieser Veranstaltung <b>austragen</b> möchtest?",
                confirmText: "Austragen",
                cancelText: "Beenden",
                type: "is-danger",
                hasIcon: true,
                onConfirm: function() {
                    self.withdraw();
                }
            };

            this.$modalDialog.confirm(props);
        },
        enlist(changeOption = null) {
            this.isLoading = true;
            var self = this;
            var url = "/events/enlist/" + this.event.id;

            var data = {
                start: this.event.start
            };

            // add user to event

            axios
                .patch(url, data)
                .then(function(response) {
                    self.event = {};
                    self.refreshEvents();
                    self.showEvent = false;
                    self.isLoading = false;
                    self.$buefy.toast.open({
                        message: "Gespeichert! Alles ist gut.",
                        type: "is-success",
                        position: "is-top-right"
                    });
                })
                .catch(function(error) {
                    if (!error.response) {
                        self.alertCustomError(error.message);
                    } else {
                        if (error.response.status == 401) {
                            // unauthorized
                            self.logout();
                        } else if (error.response.status == 419) {
                            // authentication timeout
                            self.alertSessionExpired();
                        } else {
                            self.alertCustomError(error.response.data.message);
                        }
                    }
                    self.isLoading = false;
                });
        },
        confirmEnlist() {
            var self = this;

            var props = {
                title: "Für Veranstaltung eintragen",
                message:
                    "Bist du sicher, dass du dich für diese Veranstaltung <b>eintragen</b> möchtest?",
                confirmText: "Eintragen",
                cancelText: "Beenden",
                type: "is-danger",
                hasIcon: true,
                onConfirm: function() {
                    self.enlist();
                }
            };

            this.$modalDialog.confirm(props);
        },
        register(changeOption = null) {
            this.isLoading = true;
            var self = this;
            var url = "/events/register/" + this.event.id;

            var data = {
                start: this.event.start
            };

            // add registrant to event

            axios
                .patch(url, data)
                .then(function(response) {
                    self.event = {};
                    self.refreshEvents();
                    self.showEvent = false;
                    self.isLoading = false;
                    self.$buefy.toast.open({
                        message: "Gespeichert! Alles ist gut.",
                        type: "is-success",
                        position: "is-top-right"
                    });
                })
                .catch(function(error) {
                    if (!error.response) {
                        self.alertCustomError(error.message);
                    } else {
                        if (error.response.status == 401) {
                            // unauthorized
                            self.logout();
                        } else if (error.response.status == 419) {
                            // authentication timeout
                            self.alertSessionExpired();
                        } else {
                            self.alertCustomError(error.response.data.message);
                        }
                    }
                    self.isLoading = false;
                });
        },
        confirmRegister() {
            var self = this;

            var props = {
                title: "Für Veranstaltung eintragen",
                message:
                    "Bist du sicher, dass du dich für diese Veranstaltung <b>eintragen</b> möchtest?",
                confirmText: "Eintragen",
                cancelText: "Beenden",
                type: "is-danger",
                hasIcon: true,
                onConfirm: function() {
                    self.register();
                }
            };

            this.$modalDialog.confirm(props);
        },
        deregister(changeOption = null) {
            this.isLoading = true;
            var self = this;
            var url = "/events/deregister/" + this.event.id;

            var data = {
                start: this.event.start
            };

            // remove registrant from event

            axios
                .patch(url, data)
                .then(function(response) {
                    self.event = {};
                    self.refreshEvents();
                    self.showEvent = false;
                    self.isLoading = false;
                    self.$buefy.toast.open({
                        message: "Gespeichert! Alles ist gut.",
                        type: "is-success",
                        position: "is-top-right"
                    });
                })
                .catch(function(error) {
                    if (!error.response) {
                        self.alertCustomError(error.message);
                    } else {
                        if (error.response.status == 401) {
                            // unauthorized
                            self.logout();
                        } else if (error.response.status == 419) {
                            // authentication timeout
                            self.alertSessionExpired();
                        } else {
                            self.alertCustomError(error.response.data.message);
                        }
                    }
                    self.isLoading = false;
                });
        },
        confirmDeregister() {
            var self = this;

            var props = {
                title: "Von Veranstaltung austragen",
                message:
                    "Bist du sicher, dass du dich von dieser Veranstaltung <b>austragen</b> möchtest?",
                confirmText: "Austragen",
                cancelText: "Beenden",
                type: "is-danger",
                hasIcon: true,
                onConfirm: function() {
                    self.deregister();
                }
            };

            this.$modalDialog.confirm(props);
        },
        months() {
            let baseDate = new Date(Date.UTC(2017, 0, 1));
            let months = [];
            for(let i = 0; i < 12; i++)
            {
                months.push(baseDate.toLocaleDateString(this.l, { month: 'short' }));
                baseDate.setMonth(baseDate.getMonth() + 1);
            }
            return months;
        },
        weekdaysShort(useLocaleSpecifiedOrder = true) {
            let firstDay = 0;
            if (useLocaleSpecifiedOrder) {
                firstDay = this.$refs.calendar.getApi().getOption('locale').week.dow;
            }
            let baseDate = new Date(Date.UTC(2017, 0, firstDay+1)); // 1st is a Sunday
            let weekDays = [];
            for(let i = 0; i < 7; i++)
            {
                weekDays.push(baseDate.toLocaleDateString(this.l, { weekday: 'short' }).toUpperCase());
                baseDate.setDate(baseDate.getDate() + 1);
            }
            return weekDays;
        },
        alertCustomError(message) {
            this.$buefy.dialog.alert({
                title: "Error",
                message: message,
                type: "is-danger",
                hasIcon: true,
                icon: "times-circle"
            });
        },
        alertSessionExpired() {
            var self = this;

            var props = {
                title: "Deine Sitzung ist abgelaufen",
                message: "Bitte logge dich erneut ein, um fortzufahren.",
                type: "is-danger",
                hasIcon: true,
                icon: "times-circle",
                onConfirm: function() {
                    self.logout();
                }
            };

            this.$buefy.dialog.alert(props);
        },
        logout() {
            window.location.href = "/logout";
        }
    },
    computed: {
        resources() {
            return this.locations.map(function (location) {
                return {id: location.id, title: location.name};
            });
        },
        eventSources() {
            const self = this;
            return [
                {
                    id: 'boulder-halle',
                    events(fetchInfo, successCallback, failureCallback) {

                        axios
                            .get(self.$config.app.url + "/events", {
                                params: {
                                    minDate: fetchInfo.start,
                                    maxDate: fetchInfo.end,
                                }
                            })
                            .then(function(response) {
                                var events = [];
                                response.data.forEach(function(event) {
                                    if (self.$auth.user == null && event.masked) {
                                        return;
                                    }

                                    events.push({
                                        resourceIds: event.locations.map(l => l.id),
                                        id: event.id,
                                        start: event.start,
                                        end: event.end,
                                        title: event.title,
                                        editable: event.editable,
                                        color: self.eventTypes.find(
                                            x => x.name === event.type
                                        ).color,
                                        textColor: self.eventTypes.find(
                                            x => x.name === event.type
                                        ).textColor,
                                        classNames: [
                                            ...(event.masked ? ['event-is-masked'] : []),
                                        ],
                                        rendering: event.masked && !self.isAdmin ? 'background' : '',

                                        extendedProps: {
                                            locations: event.locations,
                                            users: event.users,
                                            registrants: event.registrants,
                                            parent_id: event.parent_id || null,
                                            // official editable property is currently not accessible in event object
                                            editable: event.editable,
                                            deletable: event.deletable,
                                            withdrawable: event.withdrawable,
                                            enlistable: event.enlistable,
                                            registerable: event.registerable,
                                            deregisterable: event.deregisterable,
                                            recurrence_number: event.recurrence_number || null,
                                            change_option: event.parent_id ? "selected" : null,
                                            description: event.description,
                                            private_description: event.private_description,
                                            info_link: event.info_link,
                                            owner_name: event.owner_name,
                                            type: event.type,
                                            required_user_count: event.required_user_count,
                                            member_registrant_limit: event.member_registrant_limit,
                                            kmms_registrant_limit: event.kmms_registrant_limit,
                                            registrant_limit: event.registrant_limit,
                                            free_spots: event.free_spots,
                                            are_spots_available_for_user: event.are_spots_available_for_user,
                                            is_user_registered: event.is_user_registered,
                                            halle_frei: event.halle_frei,
                                            masked: event.masked,
                                            recurring: event.recurring,
                                            frequency: event.frequency,
                                            by_day: event.by_day_translated || [],
                                            end_repeat: event.end_repeat,
                                            count: event.count,
                                            interval: event.interval,
                                            observe_holidays: event.observe_holidays,
                                            // only set until to actual value if used; 9999-12-31 is hard for calendars to select
                                            // Safari will not parse date without the 'T' date and time separator
                                            until:
                                                event.end_repeat == "On Date"
                                                    ? new Date(event.until.replace(/ /g,"T"))
                                                    : new Date(event.end.replace(/ /g,"T")),
                                        }
                                    });
                                });
                                successCallback(events);
                            })
                            .catch(function(error) {
                                if (error.response && error.response.status == 401) {
                                    // unauthorized
                                    self.logout();
                                } else {
                                    self.alertCustomError(error.message);
                                }
                                failureCallback(error);
                            });

                    }
                }
            ];
        },
        header() {
            var header = {
                left: "title",
                center: this.filteredLocations.length == 1 ?
                    "dayGridMonth,timeGridWeek,timeGridFourDay,timeGridDay"
                    :
                    "resourceDayGridMonth,resourceTimeGridWeek,resourceTimeGridFourDay,resourceTimeGridDay",
                right: "prev,next,today,eventsFilter,locationSwitcher",
            };
            if (this.$auth.user) {
                header.center += ',listMonth';
                if (this.selectable) {
                    header.right += ',addEvent';
                }
            }
            return header;
        },
        frequencyOptions() {
            let options = [
                {
                    label: "Keine",
                    value: null,
                    disabled: false
                },
                {
                    label: "Täglich",
                    value: "DAILY",
                    disabled: false
                },
                {
                    label: "Wöchentlich",
                    value: "WEEKLY",
                    disabled: false
                },
                {
                    label: "Monatlich",
                    value: "MONTHLY",
                    disabled: false
                },
                {
                    label: "Jährlich",
                    value: "YEARLY",
                    disabled: false
                }
            ];

            _.forEach(options, (option, i) => {
                if (
                    this.originalEvent &&
                    this.originalEvent.extendedProps.frequency != option.value &&
                    !this.changeOptions.future.available
                ) {
                    options[i].disabled = true;
                }
            });

            return options;
        },
        changeOptions() {
            /**
             * change_option possibilities and how they can be applied
             *
             * event details
             * 		selected
             * 		future
             *
             * recurring turned off
             * 		all
             *
             * frequency, by_day
             * 		future
             *
             * end_repeat, until, count, interval
             * 		all
             *
             */

            var options = {
                selected: {
                    name: "Nur das Vorkommen",
                    available: true
                },
                all: {
                    name: "Alle Vorkommen",
                    available: true
                },
                future: {
                    name: "Alle zukünftigen Vorkommen",
                    available: true
                }
            };

            if (!this.originalEvent || !this.event.extendedProps.parent_id) {
                return options;
            }

            if (
                this.event.title !== this.originalEvent.title ||
                this.event.extendedProps.description !== this.originalEvent.extendedProps.description ||
                this.event.extendedProps.private_description !== this.originalEvent.extendedProps.private_description ||
                this.event.extendedProps.type !== this.originalEvent.extendedProps.type
            ) {
                options.all.available = false;
            }

            if (
                (this.event.extendedProps.frequency !== this.originalEvent.extendedProps.frequency &&
                    !(
                        this.originalEvent.extendedProps.frequency &&
                        this.event.extendedProps.frequency == null
                    )) ||
                !_.isEqual(this.event.extendedProps.by_day, this.originalEvent.extendedProps.by_day)
            ) {
                options.all.available = false;
                options.selected.available = false;
            }

            // changing from recurring to non-recurring
            if (this.originalEvent.extendedProps.frequency && this.event.extendedProps.frequency == null) {
                options.selected.available = false;
                options.future.available = false;
            }

            if (
                this.event.extendedProps.end_repeat !== this.originalEvent.extendedProps.end_repeat ||
                new Date(this.event.extendedProps.until).getTime() !=
                    new Date(this.originalEvent.extendedProps.until).getTime() ||
                this.event.extendedProps.count !== this.originalEvent.extendedProps.count ||
                this.event.extendedProps.interval !== this.originalEvent.extendedProps.interval
            ) {
                options.selected.available = false;
                options.future.available = false;
            }

            return options;
        },
        allowedEventTypes() {
            let allowedTypes = this.$auth.user.allowed_event_types;

            // allow create types if new event
            if (!this.event.id) {
                return allowedTypes.create;
            }

            // if not allowed to delete the current type, then type cannot be changed
            if (!allowedTypes.delete.includes(this.event.extendedProps.type)) {
                return [this.event.extendedProps.type];
            }

            // if updating, restrict types to those that can also be created
            return allowedTypes.update.filter(type => allowedTypes.create.includes(type) || type == this.event.extendedProps.type);
        },
        allowedLocations() {
            return this.$auth.user.allowed_locations;
        },
        isDashboardUser() {
            return this.$auth.user && this.$auth.user.is_dashboard_user;
        },
        isMember() {
            return this.$auth.user && this.$auth.user.is_member;
        },
    },
    created() {
        const self = this;

        this.businessHours = {
            daysOfWeek: this.$config.business_hours.days_of_week,
            startTime: this.$config.business_hours.start,
            endTime: this.$config.business_hours.end,
        };

        if (self.$config.plugin) {
            this.defaultView = 'resourceTimeGridFourDay';
        }

        // set isAdmin
        if (self.$auth.user && self.$auth.user.is_admin) {
            self.isAdmin = true;
        }

        // set selectable
        if (this.$auth.user == null) {
            this.selectable = false;
        } else {
            this.selectable = this.$auth.user.is_dashboard_user;
        }

        // set selectAllow
        this.selectAllow = function(selectInfo) {
            return (
                self.$auth.user.role == "Admin" ||
                selectInfo.start > new Date
            );
        };

        // set selectOverlap
        this.selectOverlap = function(event) {
            return self.$auth.user.role == "Admin" || event.extendedProps.halle_frei;
        };

        // set eventOverlap
        this.eventOverlap = function(stillEvent, movingEvent) {
            return self.$auth.user.role == "Admin" || stillEvent.extendedProps.halle_frei;
        };

        // set eventAllow
        this.eventAllow = function(dropInfo) {
            return (
                self.$auth.user.role == "Admin" ||
                dropInfo.start > new Date
            );
        };

        this.filteredLocations = this.locations;
        if (this.$route.query.locations) {
            this.filteredLocations = this.filteredLocations.filter(function (location) {
                return self.$route.query.locations.includes(location.id);
            });
        }

        this.filteredTypes = _.map(this.eventTypes, "name");
        if (this.$route.query.types) {
            this.filteredTypes = this.filteredTypes.filter(function (type) {
                return self.$route.query.types.includes(type);
            });
        }

        this.filteredKeyMasters = this.$config.key_masters;
    },
    watch: {
        filteredLocations: function() {
            var currentView = this.$refs.calendar.getApi().view.type;
            if (this.filteredLocations.length == 1 && currentView.includes('resource')) {
                currentView = currentView.replace('resource', '');
                this.$refs.calendar.getApi().changeView(currentView.slice(0,1).toLowerCase().concat(currentView.slice(1)));
            } else if (this.filteredLocations.length > 1 && !currentView.includes('resource')) {
                currentView = currentView.slice(0,1).toUpperCase().concat(currentView.slice(1));
                this.$refs.calendar.getApi().changeView('resource'.concat(currentView));
            }
            this.$refs.calendar.getApi().rerenderEvents();
        },
        filteredTypes: function() {
            this.$refs.calendar.getApi().rerenderEvents();
        },
        showOnlyUsersOwnEvents: function() {
            if (this.showOnlyUsersOwnEvents) {
                this.showEventsOfUserId = 0;
            }
            this.$refs.calendar.getApi().rerenderEvents();
        },
        showEventsOfUserId: function() {
            if (this.showEventsOfUserId == -1) {
                this.showOnlyUsersOwnEvents = false;
            }
            this.$refs.calendar.getApi().rerenderEvents();
        },
        showOnlyUsersRegisteredEvents: function() {
            if (this.showOnlyUsersRegisteredEvents) {
                this.showOnlyEventsWithSpace = false;
            }
            this.$refs.calendar.getApi().rerenderEvents();
        },
        showOnlyEventsWithSpace: function() {
            this.$refs.calendar.getApi().rerenderEvents();
        },
        'editedEvent.extendedProps.end_repeat': function(value) {
            if (value !== "After") {
                this.editedEvent.extendedProps.count = null;
            }
        },
    }
};
</script>

<style lang="scss">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@fullcalendar/list/main.css";

/* full-height calendar */
html.plugin,
html.plugin body {
    overflow: hidden;
}
#calendar-container {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 1em;
    padding: 1em 0 0;
}
.plugin #calendar-container {
    top: 0 !important;
}

/* filter pane */
.filter-pane-wrapper {
    position: fixed;
    z-index: 2;
    top: 52px;
    min-height: 29em;
    left: 0;
    width: 20em;
    transform: translateX(-100%);
    transition: .3s ease-out;
    &.is-open {
        transform: translateX(0%);
        box-shadow: 5px 0px 13px 3px rgba(0,0,0,0.1);
    }
}
.plugin .filter-pane-wrapper {
    top: 0;
}
.filter-pane {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    overflow: auto;
    padding: 1em;
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 700;
        line-height: 1.25;
        margin: -1em -1em 1em;
        padding: .75em 1em;
        background-color: #2C3E50;
        color: #fff;
        .delete {
            flex-grow: 0;
            flex-shrink: 0;
            margin-left: .75em;
        }
    }
}

/* customisations */
.fc-header-toolbar {
    margin-left: 1em;
    margin-right: 1em;
    flex-wrap: wrap;
}
.fc-icon-fa {
    font-family: FontAwesome !important;
}
.fc table th {
    text-align: center;
}
.fc-event {
    font-size: 0.8em;
}
.fc-event.event-is-masked {
    background:
        repeating-linear-gradient(
            45deg,
            transparent,
            transparent 10px, rgba(0,0,0,.2) 10px, rgba(0,0,0,.2) 20px
        );
}
.fc-event .is-registered-for-event {
    padding-left: 0.2em;
}
.datepicker.is-small .dropdown-content {
    border-radius: 2px;
    padding-bottom: 0.2rem;
    padding-top: 0.2rem;
}
.datepicker.is-small .dropdown-item {
    padding: 0.2rem 0.5rem;
}
.datepicker.is-small .pagination-previous,
.datepicker.is-small .pagination-next,
.datepicker.is-small .pagination-list .select {
    /* apply bulma is-small styles */
    border-radius: 2px;
    font-size: 0.75rem;
}
.datepicker.is-small .select select:not([multiple]) {
    padding-right: 1.5em;
}
.datepicker.is-small .select:not(.is-multiple)::after {
    right: 0.7em;
}
.datepicker.is-small .pagination-previous .icon,
.datepicker.is-small .pagination-next .icon {
    height: 1rem;
    width: 1rem;
}
.datepicker.is-small .pagination-previous .icon .fa,
.datepicker.is-small .pagination-previous .icon .mdi,
.datepicker.is-small .pagination-next .icon .fa,
.datepicker.is-small .pagination-next .icon .mdi {
    font-size: 14px;
}
.datepicker.is-small .datepicker-header {
    padding-bottom: 0.4rem;
    margin-bottom: 0.4rem;
    border-bottom: 1px solid #dbdbdb;
}
.datepicker .datepicker-table {
    margin: 0 auto 0.2rem auto;
}
.datepicker.is-small .datepicker-table .datepicker-cell {
    border-radius: 2px;
    padding: 0.2rem 0.3rem;
}

@media (max-width: 850px) {
    .fc-header-toolbar .fc-button {
        font-size: 0.8em;
    }
    .fc-header-toolbar h2 {
        font-size: 1.5em;
    }
}
</style>
